import React, { useState } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { RecAging } from "../../../../../Redux/Slice/Fas/ReceivablePayble/ReceivablePaybleSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";
export default function Ageing({ setSlotSize, slotSize }) {
  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const { RecAgingdata } = useSelector((state) => state.ReceivablePaybleSlice);

  const [inputSlotSize, setInputSlotSize] = useState(slotSize || "");

  const generateAgeingRanges = (size) => {
    const s = parseInt(size);
    const ranges = [];

    for (let i = 0; i < 5; i++) {
      const from = i * s + 1;
      const to = (i + 1) * s;
      ranges.push(`${from === 1 ? 0 : from} To ${to} Days`);
    }

    ranges.push(`Above ${5 * s} Days`);
    return ranges;
  };

  // 🔹 Ranges sirf slotSize ke hisaab se banenge
  const ranges =
    slotSize && !isNaN(slotSize)
      ? generateAgeingRanges(slotSize).reverse()
      : [];

  const getRows =
    RecAgingdata?.OutstandingData?.map((row, index, arr) => {
      const rowObj = {
        chart: true,
        // srNumber: index + 1,
        ProductionGroupMStName: row.ProductionGroupMStName,
        AgingDays: row.AgingDays,
        cumulativeBalance: row.cumulativeBalance,
      };
      ranges.forEach((range) => {
        rowObj[range] = row[range];
      });
      return rowObj;
    }) || [];

  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Production Name",
      key: "ProductionGroupMStName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Net Balance",
      key: "cumulativeBalance",
      align: "right",
      format: true,
    },
    ...ranges.map((range) => ({
      label: range,
      key: range,
      align: "right",
      format: true,
    })),
  ];

  const getRows1 =
    RecAgingdata?.ProWiseAcDtl?.map((row, index, arr) => {
      const rowObj = {
        // srNumber: index + 1,
        AcName: row.AcName,
        AgingDays: row.AgingDays,
        cumulativeBalance: row.cumulativeBalance,
      };
      ranges.forEach((range) => {
        rowObj[range] = row[range];
      });
      return rowObj;
    }) || [];

  const getColumns1 = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "Account Name", key: "AcName" },
    {
      label: "Net Balance",
      key: "cumulativeBalance",
      format: true,
      align: "right",
    },
    ...ranges.map((range) => ({
      label: range,
      key: range,
      align: "right",
      format: true,
    })),
  ];

  const handleSubmit = () => {
    if (inputSlotSize.trim() !== "" && !isNaN(inputSlotSize)) {
      setSlotSize(inputSlotSize); // parent prop update karega
    } else {
      alert("Please enter a valid slot size.");
    }
  };

  if (RecAgingdata === "no" || RecAgingdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          marginBottom: "16px",
          maxWidth: "300px",
        }}
      >
        {/* Label */}
        <div
          style={{
            fontSize: "11px",
            fontWeight: "600",
            color: isdark === "light" ? "#7c7c7c" : iscolourDark?.Colour12 || "#ffffff",
            marginBottom: "6px",
            textTransform: "uppercase",
            letterSpacing: "0.4px",
          }}
        >
          ⏺ AGEING INTERVAL (DAYS)
        </div>

        {/* Input + Button */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            background:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
            border: `2px solid ${
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour10
            }`,
            borderRadius: "10px",
            overflow: "hidden",
            padding: "4px",
            minHeight: "48px",
          }}
        >
          <input
            type="number"
            placeholder="15"
            value={inputSlotSize}
            onChange={(e) => setInputSlotSize(e.target.value)}
            style={{
              flex: 1,
              border: "none",
              outline: "none",
              background: "transparent",
              padding: "8px 10px",
              fontSize: "14px",
              color: isdark === "light" ? "#000" : "#fff",
            }}
          />

          <button
            onClick={handleSubmit}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
            }}
            style={{
              border: "none",
              borderRadius: "8px",
              padding: "8px 16px",
              fontSize: "13px",
              fontWeight: "600",
              cursor: "pointer",
              transition: "all 0.3s ease",
              transform: "scale(1)",
              background:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour10,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
            }}
          >
            Submit
          </button>
        </div>
      </div>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            AGEING
          </h2>
        </div>
        <FASTable data={getRows} columns={getColumns} />
      </div>
      <div
        className="mt-3"
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            AGEING - SET 1
          </h2>
        </div>
        <FASTable data={getRows1} columns={getColumns1} />
      </div>
    </div>
  );
}
